import React, { Component } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Big3Common } from '../../../js/IncludeManager'
import { GoodsPhoto } from '../../../js/ComponentManager'
import { format } from "date-fns";
/* 개발담당:양유빈
 * 화면기능:검색 메인화면
 * 세부설명:
*/

export class SearchHome extends Component {
    static displayName = SearchHome.name;
    constructor(props) {
        super(props);
        let thisDate = format(new Date(), "yy.MM.dd");
        this.state = {
            thisDate: thisDate,
            SearchTextList: [],
            RecentGoodList: [],
            SchTextMgtList:[]
        };
        this.CsName = Big3Common.ContentState;
        this.handleDeleteText_Click = this.handleDeleteText_Click.bind(this);
        this.handle_Click = this.handle_Click.bind(this);
        this.handleKeyword_Click = this.handleKeyword_Click.bind(this);
        this.handleGoodsLink_Click = this.handleGoodsLink_Click.bind(this);
    }
    componentDidMount() {
        this.CallRecentSearchTextData();
    }
    //최근 검색어 조회
    async CallRecentSearchTextData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get('api/Search/Goods/GetRecentSearchText');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);
                this.setState({
                    SearchTextList: DataSet.SearchText,
                    RecentGoodList: DataSet.RecentGoods,
                    SchTextMgtList: DataSet.SchTextMgt
                });
            }

        }
        catch (e) {
            console.log("CallRecentSearchTextData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //검색어 삭제
    async handleDeleteText_Click(sch_text) {
        try {
            const jsonObject = { "sch_text": sch_text };
            let Data = await Big3Common.Post('api/Search/Goods/RemoveRecentSearchText', jsonObject);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                await this.CallRecentSearchTextData();
            }
        }
        catch (e) {
            console.log("CallRecentSearchTextData", e);
        }
        return false;
    }
    //매장검색 이동
    handle_Click() {
        //이동시 키워드는 삭제 후 이동
        if (this.props.SetKeyWord !== undefined) {
            this.props.SetKeyWord("");
        }
        this.props.RenderComponent("StoreList");
        return false;
    }
    //최근검색어 클릭
    handleKeyword_Click(searchText) {
        if (this.props.SetKeyWord !== undefined) {
            this.props.SetKeyWord(searchText);
        }
        return false;
    }
    //상세이동
    handleGoodsLink_Click(event, list) {
        this.props.RenderComponent("GoodsDtl", {
            [this.CsName.Uid]: list.uid,
            [this.CsName.Goods_No]: list.goods_no,
            [this.CsName.BackUrl]: "SearchHome"
        });
        event.preventDefault();
    }
    //스와이프 스타일 조정
    GetSwiperClassName(short_text) {
        let len = short_text.length;
        if (len < 4) {
            return "word_box word_box3";
        }
        else if (len < 5) {
            return "word_box word_box4";
        }
        else if (len < 6) {
            return "word_box word_box5";
        }
        else if (len < 7) {
            return "word_box word_box6";
        }
    }
    //최근검색어
    SearchTextrender() {
        const slidersCount = 4;
        const DataList = this.state.SearchTextList;
        return (
            <>
                <div className="recent_search">
                    <div className="title_box">
                        <div className="title">최근 검색어</div>
                        <div className="all_delete" onClick={() => { this.handleDeleteText_Click('all') }}>전체삭제</div>
                    </div>
                    
                    <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="search_word_box">
                        <div>
                            {
                                DataList.map((list, idx) =>
                                    <SwiperSlide className={this.GetSwiperClassName(list.short_text)} key={idx}>
                                        <div className="word" onClick={() => { this.handleKeyword_Click(list.short_text) } }>{list.short_text}</div>
                                        <div className="delete" onClick={() => { this.handleDeleteText_Click(list.sch_text) } }></div>
                                    </SwiperSlide>
                                     
                                )}
                        </div>
                        <SwiperSlide className="word_box3">
                            {/* 공백*/}
                        </SwiperSlide>
                    </Swiper>
                    
                </div>
            </>
        );
    }
    //최근 본상품
    RescentGoodsToprender() {
        const RecentGoodList = this.state.RecentGoodList;
        const slidersCount = 3;
        
        return (
            <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="recent_poroducts row row-cols-3 no_line">
                <div>
                    {
                        RecentGoodList.map((list, idx) =>
                            <SwiperSlide key={idx} className="product" onClick={(e) => { this.handleGoodsLink_Click(e, list) }}>
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                    Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                    CallBack={this.CallBoorkMarkGoodsData}
                                    SoldoutYn={list.soldout_yn}
                                  
                                />
                                <div className="shop_name">{list.org_nm}</div>
                                <div className="product_name">{list.goods_nm}</div>
                                <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원` }</div>
                                {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                            </SwiperSlide>
                        )}
                </div>
                <SwiperSlide>
                    {/* 공백*/}
                </SwiperSlide>
            </Swiper>
        )
    }
    SearchRankrender() {
        const SchTextMgtList = this.state.SchTextMgtList;
        const List1 = [];
        const List2 = [];
        SchTextMgtList.forEach((list,idx) => {
            if (idx < 5) {
                List1.push({ "sch_text": list.sch_text });
            }
            else {
                List2.push({ "sch_text": list.sch_text });
            }
        });
        return (
            <div className="search_rank">
                <div className="title_box">
                    <div className="title">검색랭킹</div>
                    <div className="standard_Time">{this.state.thisDate} 00:00 기준</div>
                </div>
                <div className="ranking_box">
                    <div className="ranking first_Fifth">
                        {
                            List1.map((list, idx) =>
                                <div className="place" key={idx } onClick={() => { this.handleKeyword_Click(list.sch_text) }}>{idx < 3 ? <span className="top">{idx + 1}</span> : <span>{idx + 1}</span>}{list.sch_text}</div>
                            )
                        }
                    </div>
                    <div className="ranking sixth_tenth">
                        {
                            List2.map((list, idx) =>
                                <div className="place" key={idx} onClick={() => { this.handleKeyword_Click(list.sch_text)}}><span>{(idx+6)}</span>{list.sch_text}</div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const SearchTextrender = this.SearchTextrender();
        const RescentGoodsToprender = this.RescentGoodsToprender();
        const SearchRankrender = this.SearchRankrender();
        return (
            <>
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap tap_on">상품</div></div>
                    <div className="n_tap"><div className="alert_tap" onClick={() => { this.handle_Click() } }>매장</div></div>
                </div>
                <div className="a_margin d_padding container_box">
                    {SearchTextrender}
                    <div className="recent_product">
                        <div className="title_box">
                            <div className="title">최근  본 상품</div>
                        </div>
                        <div className="recent_poroducts">
                            {RescentGoodsToprender }
                        </div>
                    </div>
                    {SearchRankrender}
                </div>
            </>
          
        );
    }
}
